'use strict';

import {module} from '../app';
import { constantStrings } from "../constants/constantStrings";

module
  .factory('PatientReferringPhysiciansDialogModel', ['ReferencePhysician', 'AddReferringPhysicianDialogModel', 'modalService',

    function (ReferencePhysician, AddReferringPhysicianDialogModel, modalService) {

      function PatientReferringPhysiciansDialogModel(patient, checkIfStillOwningAndNotOffline) {

        const DEFAULT_REFPHIES_LIST_PAGE_INDEX = 0;
        const DEFAULT_NETWORK_UNAVAILABLE_STATUS = -1;

        let self = this;

        self.patient = patient;
        self.refPhys = patient.ReferringPhysicians.filter(x => !!x);
        self.getAllRefPhyPromise = null;
        self.pageIndex = 0;
        self.query = undefined;
        self.stopInfiniteLoad = true;
        self.isLoadingMore = false;
        self.loadedRefPhies = [];
        self.templateData = {
          showLoadMore: true
        };
        self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;

        self.init = function (modal, scope) {
          self.modalInstance = modal;
          self._scope = scope;
          self.data = {};
          if (patient.ReferringPhysicians && patient.ReferringPhysicians.length > 0) {
            for (let index = 0; index < constantStrings.MaxRefPhiesPerPatient; index++) {
              if (self.patient.ReferringPhysicians[index]) {
                self.data[index] = self.patient.ReferringPhysicians[index].RefNum;
              }
            }
          }
          else {
            patient.ReferringPhysicians = new Array(constantStrings.MaxRefPhiesPerPatient);
          }
          self.refPhys.forEach(item => {
            if (item) {
              item.DisplayName = composeRefPhyDisplayName(item);
            }
          });
        };

        self.processRefPhiesOnLoadError = function(error){
          if (self.canceledLoadRefPhys) {
            return;
          }
          self.stopInfiniteLoad = true;

          let message = error.statusText;

          if (error.status == DEFAULT_NETWORK_UNAVAILABLE_STATUS) {
            message = networkUnavailableMessage;
          }

          const result = { List: [], IsError: true, ErrorMessage: message };

          return result;
        };

        self.getRefPhyAutocomplete = function (query, currentRefPhyIndex) {

          if (self.query === query) {
            self.pageIndex++;
            self.isLoadingMore = true;
          } else {
            self.isLoadingMore = false;
          }

          if (!self.query) {
            self.query = '';
          }

          self.query = query;

          if (self.getAllRefPhyPromise && self.getAllRefPhyPromise.canceler) {
            self.canceledLoadRefPhys = true;
            self.getAllRefPhyPromise.canceler.resolve();
          }

          var usedRefPhyKeys = [];
          for (var o in self.data) {
            usedRefPhyKeys.push(self.data[o] && self.data[o][0]);
          }

          self.getAllRefPhyPromise = ReferencePhysician.loadForAutocomplete(query, self.pageIndex || 0, usedRefPhyKeys);
          return self.getAllRefPhyPromise
            .then(function (response) {
              self.canceledLoadRefPhys = false;
              self.stopInfiniteLoad = response.data.length === 0;
              self.templateData.showLoadMore = !self.stopInfiniteLoad;

              const newMapArray = response.data.map(function (record) {
                record.DisplayName = composeRefPhyDisplayName(record);
                return record;
              });
              if (self.isLoadingMore) {
                self.loadedRefPhies = self.loadedRefPhies.concat(newMapArray);
              } else {
                self.loadedRefPhies = newMapArray;
              }

              return {
                List: self.loadedRefPhies,
                IsError: false,
                ErrorMessage: ''
              }
            }, function (error) {
              const response = self.processRefPhiesOnLoadError(error);
              return response;
            });
          return promise;
        };

        self.getRefPhyByKey = async function (selectedKey) {

          if (!selectedKey || !selectedKey.length) {
            return;
          }

          let filteredRefPhys = self.getRefPhyFromCache(selectedKey);
          if (filteredRefPhys && filteredRefPhys.length) {
            return filteredRefPhys;
          }

          filteredRefPhys = self.getRefPhyFromRecentAutocomplete(selectedKey);
          if (filteredRefPhys && filteredRefPhys.length) {
            return filteredRefPhys;
          }

          let refPhy = await ReferencePhysician.get(Array.isArray(selectedKey) ? selectedKey[0] : selectedKey);
          if (refPhy && !self.refPhys.some(ref => ref.RefNum.trim() === refPhy.RefNum.trim())) {
            refPhy.DisplayName = composeRefPhyDisplayName(refPhy);
            self.refPhys.push(refPhy);
          }
          return [refPhy];
        };

        self.getRefPhyFromCache = function (selectedKey) {
          return self.getRefPhyFromArray(selectedKey, self.refPhys);
        }

        self.getRefPhyFromRecentAutocomplete = function (selectedKey) {
          let items = self.getRefPhyFromArray(selectedKey, self.loadedRefPhies);
          items.forEach(item => {
            if (item && !self.refPhys.some(ref => ref.RefNum.trim() === item.RefNum.trim())) {
              self.refPhys.push(item);
            }
          });
          return items;
        }

        self.getRefPhyFromArray = function (selectedKey, array) {
          if (!array || array.length == 0) {
            return [];
          }
          return array.filter(function (element) {
            if (Array.isArray(selectedKey)) {
              return element.RefNum === selectedKey[0];
            } else {
              return (element.RefNum && element.RefNum.trim()) === (selectedKey && selectedKey.trim());
            }
          });
        }

        self.onRefPhySelectionChange = function (index, callback) {
          self.resetAutocomplete();
        };

        self.addReferringPhysican = async function () {
          let model = new AddReferringPhysicianDialogModel(self.patient, self.checkIfStillOwningAndNotOffline);
          let response = await modalService.showDialogWindow('views/templates/addReferringPhysicianDialogModel.html', model);
          if(response.isOwnershipLost){
             self.modalInstance.remove();
            return;
          }
          if (response.isAdded) {
            self.resetAutocomplete();
          }
        }

        self.resetAutocomplete = function () {
          self.query = undefined;
          self.pageIndex = 0;
          self.isLoadingMore = false;
        }

        self.save = function () {
          for (let index = 0; index < constantStrings.MaxRefPhiesPerPatient; index++) {
            if (self.data[index] && self.data[index].length && self.data[index][0]) {
              self.patient.ReferringPhysicians[index] = self.refPhys.find(item => item.RefNum.trim() === self.data[index][0].trim());
            } else {
              self.patient.ReferringPhysicians[index] = null;
            }
          }
          self.modalInstance.remove();
        };
      }

      function composeRefPhyDisplayName(item) {
        return `${item.LastName && item.LastName.trim()} ${item.FirstName && item.FirstName.trim()} (${item.RefNum.trim()})`
      }

      return PatientReferringPhysiciansDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/patientReferringPhysiciansDialogModel.js